import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { OFFICE_INTRO_SAMPLE } from "../consts";
import { OfficeSceneProps } from "../types";

/** Korak "Adrese": karta s oznakom poslovnice i popis adresa, jedna je glavna. */
const OfficeAddressScene: React.FC<OfficeSceneProps> = ({ name }) => {
  const [mainAddress] = OFFICE_INTRO_SAMPLE.addresses;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          {/* Karta: mreža ulica i oznaka poslovnice u sredini. */}
          <div className="relative h-[10rem] rounded-md bg-emerald-50 overflow-hidden">
            <span className="absolute inset-x-0 top-[35%] h-2 bg-white" />
            <span className="absolute inset-x-0 top-[72%] h-1.5 bg-white" />
            <span className="absolute inset-y-0 left-[30%] w-2 bg-white" />
            <span className="absolute inset-y-0 left-[70%] w-1.5 bg-white" />
            <span className="absolute left-[8%] top-[48%] w-[18%] h-[18%] rounded-sm bg-emerald-100" />
            <span className="absolute left-[76%] top-[8%] w-[18%] h-[22%] rounded-sm bg-emerald-100" />
            <span className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-full">
              <svg className="w-8 h-8 drop-shadow" viewBox="0 0 24 24" fill="#1D4ED8" aria-hidden="true">
                <path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" />
              </svg>
            </span>
          </div>

          <div className="mt-3 text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400 truncate">{name}</div>
          <div className="text-sm font-bold text-slate-800 truncate">{mainAddress.line}</div>
          <div className="text-[0.65rem] text-slate-400 truncate">{mainAddress.city}</div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Adrese</div>
          <div className="mt-2 space-y-2">
            {OFFICE_INTRO_SAMPLE.addresses.map((address, index) => (
              <div key={address.line} className="rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-semibold text-slate-700 truncate">{address.line}</span>
                  {index === 0 && (
                    <span className="px-1.5 py-0.5 rounded-full text-[0.55rem] font-semibold bg-blue-100 text-blue-700">
                      {address.label}
                    </span>
                  )}
                </div>
                {index > 0 && <div className="text-[0.6rem] text-slate-400 truncate">{address.label}</div>}
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Više adresa po poslovnici"
          subtitle="Jedna je uvijek glavna"
          iconClassName="bg-emerald-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#047857" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M9 20l-6-3V4l6 3 6-3 6 3v13l-6-3-6 3zM9 7v13M15 4v13" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(OfficeAddressScene);
